module.exports = __webpack_public_path__ + "media/crown.144526ed.mp3";